import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ImgConfigurationPipe } from '@shared/pipes/img-config.pipe';

@Component({
  selector: 'app-image',
  imports: [CommonModule, ImgConfigurationPipe],
  templateUrl: './image.component.html',
  styleUrl: './image.component.css'
})
export class ImageComponent {
  @Input() imageName!: string;
  @Input() defaultValue!: string;
  @Input() width?: string = 'auto';
  @Input() height?: string = 'auto';

}
